import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import Footer from '../../GlobalComp/Footer/Footer';
import Classes from './ContactUs.module.css';
import { fadeUpVariant } from '../../../utils/motionVariants';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Logo from '../Home/Components/Logo/Logo';
import backend from '../../../api';

export default function ContactUs() {
  const navigateTo = useNavigate();
  const { user } = useSelector((state) => state.auth);

  const [formdata, setformdata] = useState({
    firstName: '',
    lastName: '',
    email: '',
    message: '',
  });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setformdata((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // stop the form’s default reload
    const { firstName, lastName, email, message } = formdata || {};

    // basic validation
    if (!firstName?.trim() || !lastName?.trim() || !email?.trim() || !message?.trim()) {
      alert('Please fill all fields');
      return;
    }

    const body = {
      fullname: `${firstName.trim()} ${lastName.trim()}`,
      email: email.trim(),
      message: message.trim(),
    };

    try {
      setSubmitting(true);
      const res = await backend.post('/contact', body);
      if (res?.status === 200) {
        alert('Email sent successfully');
        // clear the form
        setformdata({ firstName: '', lastName: '', email: '', message: '' });
      }
    } catch (err) {
      console.error(err);
      alert('Something went wrong while sending the email');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <div className={Classes.hero}>
        <motion.div className={Classes.navbar}>
          <a href="/" style={{ textDecoration: 'none' }} className={Classes.logoMargin}>
            <div>
              <div className="logo">
                <h5 style={{ color: 'white' }}>Mentr</h5>
                <h3 style={{ color: 'white' }}>Mentr</h3>
              </div>
            </div>
          </a>
          <div>
            <h5 className={Classes.text} onClick={() => { navigateTo('/') }} >Go to {user ? 'Dashboard' : 'Home'}</h5>
          </div>
        </motion.div>

        <div className={Classes.heroContent}>
          <div className={Classes.heading}>
            <motion.h1 {...fadeUpVariant(0.1)}>Contact Us</motion.h1>
          </div>

          <motion.form
            {...fadeUpVariant(0.3)}
            className={Classes.formContainer}
            onSubmit={handleSubmit}
            noValidate
          >
            <div className={Classes.twoElem}>
              <input
                type="text"
                name="firstName"
                className={Classes.inputField}
                placeholder="First Name"
                value={formdata.firstName}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="lastName"
                className={Classes.inputField}
                placeholder="Last Name"
                value={formdata.lastName}
                onChange={handleChange}
                required
              />
            </div>

            <input
              type="email"
              name="email"
              className={Classes.inputField}
              placeholder="Email"
              value={formdata.email}
              onChange={handleChange}
              required
            />

            <textarea
              name="message"
              className={Classes.textareaField}
              placeholder="Message..."
              autoCorrect="off"
              spellCheck="false"
              rows={7}
              value={formdata.message}
              onChange={handleChange}
              required
            />

            <button type="submit" disabled={submitting} className={Classes.submitButton}>
              <h5>{submitting ? 'Sending…' : 'Send Message'}</h5>
            </button>
          </motion.form>
        </div>
      </div>

      {!user && <Footer />}
    </>
  );
}
